import Layout from '@/layout';

const enterpriseRouter = {
  path: `/enterprise`,
  component: Layout,
  redirect: `/enterprise/enterpriseInfo`,
  alwaysShow: true, // will always show the root menu
  name: 'enterprise',
  meta: {
    id: 8,
    title: '企业管理',
    icon: 'yzs_qiyeguanli',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL'],
  },
  children: [
    {
      path: 'enterpriseInfo',
      component: () => import('@/views/enterprise/info'),
      name: 'EnterpriseInfo',
      meta: {
        id: 81,
        title: '企业列表',
        roles: ['SUPER_ADMIN'],
      },
    },
    {
      path: 'enterpriseInfo/create',
      name: 'enterpriseInfocreate',
      component: () => import('@/views/enterprise/info/create.vue'),
      hidden: true,
      meta: {
        id: 811,
        title: '创建企业',
      },
    },
    {
      path: 'enterpriseInfo/detail',
      component: () => import('@/views/enterprise/info/corpDetail/index'),
      name: 'detail',
      hidden: true,
      meta: {
        id: 812,
        title: '企业详情',
        roles: ['SUPER_ADMIN'],
      },
    },
    {
      path: 'accountCenter',
      component: () => import('@/views/enterprise/accountCenter'),
      name: 'AccountCenter',
      meta: {
        id: 82,
        title: '账户中心',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE'],
      },
    },
    {
      path: 'accountCenter/netGoods',
      component: () => import('@/views/enterprise/accountCenter/transactionNetGoods'),
      name: 'TransactionNetGoods',
      hidden: true,
      meta: {
        id: 821,
        title: '平安交易明细',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE'],
      },
    },
    {
      path: 'accountCenter/transactionSTWL',
      component: () => import('@/views/enterprise/accountCenter/transactionSTWL'),
      name: 'TransactionSTWL',
      hidden: true,
      meta: {
        id: 821,
        title: '神通交易明细',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE'],
      },
    },
    {
      path: 'accountCenter/etcReconciliation',
      component: () => import('@/views/enterprise/accountCenter/etcReconciliation'),
      name: 'etcReconciliation',
      hidden: true,
      meta: {
        id: 822,
        title: 'ETC对账',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE'],
      },
    },
    {
      path: 'accountCenter/oilReconciliation',
      component: () => import('@/views/enterprise/accountCenter/oilReconciliation'),
      name: 'oilReconciliation',
      hidden: true,
      meta: {
        title: '油气交易明细',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE'],
      },
    },
    {
      path: 'project',
      component: () => import('@/views/enterprise/projectManage'),
      name: 'ProjectManage',
      meta: {
        id: 83,
        title: '项目列表',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
    {
      path: 'routeInfo',
      component: () => import('@/views/enterprise/routeManage'),
      name: 'RouteInfo',
      meta: {
        id: 84,
        title: '线路列表',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL'],
      },
    },
    {
      path: 'employManage',
      component: () => import('@/views/enterprise/employManage'),
      name: 'EmployManage',
      meta: {
        id: 85,
        title: '员工管理',
        roles: ['SUPER_ADMIN'],
      },
    },
    {
      path: 'systemSetting',
      component: () => import('@/views/enterprise/systemSetting'),
      name: 'SystemSetting',
      meta: {
        id: 86,
        title: '系统设置',
        roles: ['SUPER_ADMIN'],
      },
    },
  ],
};
export default enterpriseRouter;
